import { Button } from "components/Button/Button";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useRef, useState } from "react";
import { MessageType } from "types/enum";
import { GUID_EMPTY, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { ConvertiSolarDateToGregorianDate, trans } from "utils/helpers";
import { getWarehouseIoNo } from "./api";

import { WarehouseDictionaryWithAccess } from "pages/InventoryAndSales/Sales/SalesInvoice/components/WarehouseDictionary/WarehouseDictionaryWithAccess";

import { TransfetRemittanceSourceId } from "./TransfetRemittanceSourceId";

import { TransferReceiptViewForm } from "./TransferReceiptViewForm";

interface Props {
  mode: string;
  showForm: boolean;
  selectedObj: any;
  jobId?: any;
  JobNo?: any;
  processId?: any;
  referenceId?: any;
  taskId?: any;
  onHide: (e) => void;
  reload: () => void;
  warehouseIoEnaumType?: any;
  setShowWarehouseIoForm;
  sourceId?: any;
  SourceData?: any;
  sourceDataParam?: any;
  data?: any;
  handleSendData?: any;
  constraint?: any;
  showWarehouseTypeForm?: any;
  initialResponse?: any;
  childResponseList?: any;
}

export const TransferReceiptForm = ({
  mode,
  selectedObj,
  onHide,
  taskId,
  jobId,
  JobNo,
  warehouseIoEnaumType, //enum => exmaple TransferReceipt is enum 3 so result is 3
  data,
  handleSendData,
  constraint,
  initialResponse,
  showWarehouseTypeForm,
  reload,
  childResponseList,
}: Props) => {
  const [fromDate, setFromDate] = useState<string | null>(null);
  const [warehouseIODate, setWarehouseIODate] = useState<any>(null);

  const [haveSource, setHaveSource] = useState(null);

  const [resetForm, setResetForm] = useState(false);
  const [recipientPerson, setRecipientPerson] = useState<any>({});
  const [accountPartyPerson, setAccountPartyPerson] = useState<any>({});
  const [deliverPerson, setDeliverPerson] = useState<any>({});
  const [transferRemittanceId, setTransferRemittanceId] = useState<any>(data?.SourceId?data?.SourceId:null);
  const [response, setResponse] = useState<any>(data);
  const [applicantPosition, setApplicantPosition] = useState<any>({});
  const [userChanges, setUserChanges] = useState({});



  const [docsClassification, setDocsClassification] = useState<any>({});
  const myform = useRef<any>(null);
  const [warehouseIoDetail, setWarehouseIoDetail] = useState<any>(
    data?.TransferReceiptDetailDTOList || []
  );
  const [detailMode, setDetailMode] = useState<any>([]);

  const [totalRow, setTotalRow] = useState<any>({
    QtyIn1: data?.ItemCount ? data?.ItemCount : 0,
  });
  const [registerByQuantityDate, setRegisterByQuantityDate] =
    useState<any>(null);
  const [registerByPriceDate, setRegisterByPriceDate] = useState<any>(null);

  const [showDetailForm, setShowDetailForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);

  const [warehouseData, setWarehouseData] = useState<any>({
    Warehouse: JSON.parse(localStorage.getItem("DefaultInventory") as any)
      ?.Name,
    WarehouseId: JSON.parse(localStorage.getItem("DefaultInventory") as any)
      ?.Id,
      WarehouseDetailId:data?.TransferReceiptDetailDTOList?.[0].WarehouseDetailId
  });
  const [time, setTime] = useState(new Date().toISOString());
  const [nextInvoiceNumber, setNextInvoiceNumber] = useState<any>();
  const [requiredFields, setRequiredFields] = useState<any>();

  const getWarehouseIoNoAsync = async () => {
    try {
      const res = await getWarehouseIoNo(
        docsClassification?.Id != GUID_EMPTY ? docsClassification?.Id : null,
        mode == "create" && !jobId
          ? warehouseData?.WarehouseId
          : response.WarehouseId,
        warehouseIoEnaumType,
        response.WarehouseIONo !== 0 || mode !== "create" ? response.Id : null
      );
      setNextInvoiceNumber(res.Data);
    } catch (error: any) {}
  };

  const handleSubmit = async (e, sendData, detail = warehouseIoDetail) => {
    const dataCollect = {
      TAS_UID: null,
      WarehouseId:
        mode == "create" && !jobId
          ? warehouseData.WarehouseId
          : response.WarehouseId,
      WarehouseDetailId: warehouseData.WarehouseDetailId,
      WarehouseIODate: fromDate || "",
      TransferRemittanceId: transferRemittanceId,
    };

    let url = "FromSource" as any;
    if (jobId) {
      //   const diff1 = warehouseIoDetail?.filter(a => !(initialResponse?.TransferReceiptDetailDTOList as any).some((b:any)  => b.ItemCode === a.ItemCode));
      //  const diff2 = (initialResponse?.TransferReceiptDetailDTOList as any)?.filter(a => !warehouseIoDetail?.some(b => b.ItemCode === a.ItemCode));
      //  const differences = [...diff1, ...diff2];

      //  const mismatchedQty = warehouseIoDetail?.filter(item1 => {
      //    const match = (initialResponse?.TransferReceiptDetailDTOList as any)?.find(item2 => item2.ItemCode === item1.ItemCode);
      //    return match && item1.QtyIn1 !== match.QtyIn1;
      //   });
      //   if(!!differences?.length){ url='FromSourceWithItemEdit'}
      // else if(!!mismatchedQty?.length){ url='FromSourceWithQtyEdit'}

      if (
        initialResponse?.TransferReceiptDetailDTOList?.length !=
        warehouseIoDetail?.length
      ) {
        url = "FromSourceWithItemEdit";
      } else {
        warehouseIoDetail.map((item) => {
          let flag = false;

          const foundWithQtyDiff =
            initialResponse?.TransferReceiptDetailDTOList.some((res) => {
              if (item?.ItemCode == res?.ItemCode) {
                flag = true;
                if (item?.QtyIn1 != res?.QtyIn1) {
                  url = "FromSourceWithQtyEdit";
                }
                return true; // متوقف کردن حلقه some
              }
              return false;
            });

          if (!flag) {
            url = "FromSourceWithItemEdit";
          }
        });
      }
    }

    handleSendData(
      {
        ...dataCollect,
        // JobId: jobId,
        // JobNo: response?.JobNo ? response?.JobNo : JobNo,
        // TAS_UID: taskId,
        // Id: response?.Id,
      },
      initialResponse?.SourceId ? url : null,
      sendData
    );
    // اگر در فرایند باشد و سورس نداشته باشد باید  به ادمیدل درخواست بزند
    // اگر در فرایند باشد و سورس داشته باشه باید به فرامسورس و ... درخواست بزند
    //اگر در فرایند نباشد سورس داشته باشد به فرامسورس درخواست بزند
    //اگر در فرایند نباشد و سورس نداشته باشد پست معمولی است
    if (sendData) {
      showWarehouseTypeForm != 3 && onHide && onHide(true);
    }
  };


  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide && onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide && onHide(true);
      });
    } else {
      onHide && onHide(true);
    }
  }

  const handleDeleteRow = async (id: string = selectedObj?.Id) => {
    let newPriceListDetail: any = [...warehouseIoDetail];
    let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

    setTotalRow({
      QtyIn1: totalRow.QtyIn1 - obj.QtyIn1,
    });
    const detais = newPriceListDetail.filter((e) => e.Id != id);
    setWarehouseIoDetail(detais);
    handleSubmit(null, false, detais); //برای وقتی از مستر یکی داریم و تا روی دکمه ذخیره کلیک نکنه دیتای دیتیل اپدیت نمیشه پس مجبوریم با هر تغییر دیتیل یکبار دیتارو با صدا زدن تابع اپدیت کنیم بفرستیم بالا
  };

  const selectedObjCallback = (obj, index) => {
    setSelectedRow(obj);
  };

  useEffect(() => {
    setRequiredFields(
      constraint?.RequiredFields ? JSON.parse(constraint?.RequiredFields) : null
    );
    if (constraint?.IsDocClassified) {
      if (mode == "create" || response.WarehouseIONo === 0) {
        getWarehouseIoNoAsync();
      } else {
        setNextInvoiceNumber(response.WarehouseIONo);
      }
    } else {
      if (mode == "create" && !jobId) {
        setNextInvoiceNumber(
          constraint?.DocNoDictionary?.[warehouseData.WarehouseId]
        );
      }
    }
  }, []);

  useEffect(() => {
    setWarehouseIoDetail(
      data?.TransferReceiptDetailDTOList
        ? data?.TransferReceiptDetailDTOList
        : []
    );
    let newItemCount = 0;
    data?.TransferReceiptDetailDTOList.map((item) => {
      newItemCount += item.QtyIn1;
    });
    setTotalRow({
      QtyIn1: newItemCount,
    });
  }, [data?.TransferReceiptDetailDTOList]);








  return (
    <div className="card">
    {mode=='create' &&  <>
        <form className={"card-body"} ref={myform}>
          <div className="row px-2 py-1">
            <div className="col-11 col-lg-2 ms-3 mb-1">
              <TransfetRemittanceSourceId
                SourceObjCallBack={(id,date) => {
                  setTransferRemittanceId(id);
                  setWarehouseIODate(ConvertiSolarDateToGregorianDate(date.split(" ")[0]))
                }}
                resetForm={resetForm}
                warehouseId={warehouseData.WarehouseId}
                mode={mode}
                SourceDataType={response?.SourceDataType}

              />
            </div>

            <div className="col-11 col-lg-3">
              <Datepicker
                Change={(e) => {
                  setUserChanges({ ...userChanges, ...e });
                }}
                mode={constraint?.IsNewDocCurrentDate ? "view" : mode}
                resetForm={resetForm}
                lable="Date"
                setIsoTime={(isoTime: string) => {
                  setFromDate(isoTime);
                }}
                val={response?.WarehouseIODate ?? time}
                required={requiredFields?.WarehouseIODate}
                maxDate={new Date()}
                minDate={warehouseIODate}
              />
            </div>

            <div className="col-11 col-lg-3">
              <WarehouseDictionaryWithAccess
                name="WarehouseId"
                label="Warehouse"
                onChange={(e, obj) => {
                  setWarehouseData({
                    WarehouseId: e,
                    WarehouseTitle: obj.Name.Description,
                    WarehouseDetailsCount: obj.Name.WarehouseDetailsCount,
                  });
                }}
                mode={"view"}
                value={
                  !jobId ? warehouseData?.WarehouseId : response?.WarehouseId
                }
                valueString={''}
                required={requiredFields?.WarehouseId}
              />
            </div>
            <div className="col-11 col-3">
  {((warehouseData?.WarehouseDetailId &&
              warehouseData?.WarehouseDetailId != GUID_EMPTY) ||
              warehouseData?.WarehouseDetailsCount > 0) && (
              <div className="col-lg-3">
                <div className="">
                  <DictionarySelectBox
                    name="WarehouseDetail"
                    label="WarehouseDetail"
                    params={{ warehouseId: warehouseData?.WarehouseId }}
                    onChange={(e, obj) => {
                      setWarehouseData((prev) => {
                        return {
                          ...prev,
                          WarehouseDetailId: e,
                          WarehouseDetail: obj?.Name,
                        };
                      });
                    }}
                    baseUrl={INVENTORYANDSALES_URL}
                    endPoint={
                      ENDPOINTSINVENTORYANDSALES.Inventory.BaseInformationApi
                        .WarehouseDetail.dictionary
                    }
                    value={warehouseData?.WarehouseDetailId}
                    resetForm={resetForm}
                    valueString={''}
                    mode={mode}
                  />
                </div>
              </div>
            )}

            </div>

          
          </div>
        </form>

        <div className="mb-2">
      
            <div className="col-lg-12  btns_form mb-3">
              <Button
                // disabled={!(salesOrderDetail.length > 0)}
                value="save"
                btnType="submit"
                onClick={(e) => handleSubmit(e, true)}
                disabled={!transferRemittanceId}
              />

              <Button
                btnType="cancel"
                value="Cancel"
                onClick={() => {
                  cancel();
                }}
              />
            </div>
 
            {/* <div className="col-lg-12 mt-1 btns_form mb-3">
              <Button
                btnType="primary"
                value="close"
                onClick={() => {
                  cancel();
                }}
              />
            </div> */}
      
        </div>
      </>}
      {
        mode=='view' &&
        <TransferReceiptViewForm
       mode={mode}
  selectedObj={selectedObj}
  onHide={onHide}
  taskId={taskId}
  jobId={jobId}
  JobNo={JobNo}
  warehouseIoEnaumType={warehouseIoEnaumType}
  data={data}
  handleSendData={handleSendData}
  constraint={constraint}
reload={reload}
  initialResponse={initialResponse}
  showWarehouseTypeForm={showWarehouseTypeForm}
  childResponseList={childResponseList}
        />
      }
    </div>
  );
};
